module.exports = __webpack_public_path__ + "dist/assets/0c8eae17f7da97528187c1587ace36e0.woff";